<template>
  <div>
    <ModalGrupoComissao
      :close="closeModalGrupoComissao"
      :currentItem="currentItem"
    />
    <Loading :isActive="loading"></Loading>
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Grupos de Comissão">
        <div>
          <div class="filters row" style="margin-top: 0">
            <div class="col-1-3">
              <span class="filters__search">
                <input
                  type="text"
                  v-model="filtros.termo"
                  placeholder="Buscar por..."
                  v-on:input="debounceLoadGrupos()"
                />
                <img
                  style="position: relative; right: -10px"
                  src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
                />
              </span>
            </div>

            <div class="col-1-2">
              <div
                class="col-1-3 d-flex justify-content-center align-items-stretch border rounded border-1"
              >
                <div
                  class="d-flex mr-1 justify-content-center align-self-stretch align-items-center"
                >
                  <!-- Icone de sort asc e desc, troca ao clicar -->

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="15"
                    style="cursor: pointer"
                    height="15"
                    v-if="filtros.order == 'asc'"
                    v-on:click="
                      filtros.order = 'desc';
                      loadGrupos();
                    "
                  >
                    <path
                      d="M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="15"
                    height="15"
                    style="cursor: pointer"
                    v-if="filtros.order == 'desc'"
                    v-on:click="
                      filtros.order = 'asc';
                      loadGrupos();
                    "
                  >
                    <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) -->
                    <path
                      d="M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                    />
                  </svg>
                </div>

                <select
                  class="form-control border-0 px-0"
                  v-model="filtros.colunaId"
                  v-on:change="loadGrupos()"
                >
                  <option
                    v-for="i in table.columns"
                    v-bind:value="i.column"
                    v-bind:key="i.column"
                  >
                    {{ i.label }}
                  </option>
                </select>
              </div>
              <div class="pull-right">
                <button
                  v-on:click="openModalGrupoComissao()"
                  class="button button-success button-block"
                >
                  <fa-icon icon="plus" />
                  Novo {{ descSingular }}
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <datatable
              :columns="table.columns"
              :data="items"
              :filter-by="filtros.termo"
              class="table table-hover"
            >
              <template slot-scope="{ row }">
                <RowGrupoComissao
                  :grupoComissao="row"
                  :deleteConfirm="deleteConfirm"
                  :openEdit="openEdit"
                />
              </template>
            </datatable>
          </div>
          <pagination
            :data="table.paginator"
            :limit="2"
            @pagination-change-page="loadGrupos"
          ></pagination>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import _debounce from "lodash/debounce";
import { uuid } from "vue-uuid";
import { get, del } from "../../helpers/apiRequest";

import ModalGrupoComissao from "./ModalGrupoComissao/ModalGrupoComissao.vue";
import RowGrupoComissao from "./RowGrupoComissao/RowGrupoComissao.vue";
import clone from "just-clone";

export default {
  name: "crud-template",
  components: { ModalGrupoComissao, RowGrupoComissao },
  data() {
    return {
      loading: false,
      items: [],
      filtros: {
        termo: "",
        tipoId: "",
        colunaId: "id",
        order: "asc",
      },
      currentItem: {},
      table: {
        filter: "",
        columns: [
          { id: 1, label: "ID", field: "id", column: "id", sortable: false },
          {
            id: 2,
            label: "Nome",
            field: "nome",
            column: "nome",
            sortable: false,
          },
          {
            id: 3,
            label: "Criação",
            field: "dtCriacao",
            column: "datacriacao",
            sortable: false,
          },
          {
            label: "Últ. Atualização",
            field: "dtAtualizacao",
            column: "dataatualizacao",
            sortable: false,
          },
          { label: "Ativo", field: "ativo", column: "ativo", sortable: false },
          { label: "", field: "", column: "", sortable: false },
        ],
        paginator: {},
      },
    };
  },
  methods: {
    openModalGrupoComissao() {
      this.currentItem = {};
      this.$modal.show("ModalGrupoComissao");
    },
    closeModalGrupoComissao() {
      this.$modal.hide("ModalGrupoComissao");
      this.reloadKey = uuid.v4();
      this.loadGrupos();
    },
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem("app"));
      const { parametros } = JSON.parse(localStorage.getItem("app"));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === "ADMIN_COLABORADOR"
      );
      this.parametros = parametros;
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadGrupos(page = 1, take = 15) {
      this.loading = true;
      get(
        `/admin/grupo-comissao?page=${page}&take=${take}&q=${this.filtros.termo}&tipo=${this.filtros.tipoId}&column=${this.filtros.colunaId}&order=${this.filtros.order}`
      )
        .then((json) => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.hasAguardando =
            json.filter((i) => +i.aguardando === 1).length > 0;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    deleteConfirm(item) {
      const { id } = item;

      this.$swal({
        title: "Confirmar remoção?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
      })
        .then((res) => {
          if (!!res.isConfirmed) {
            this.loading = true;
            del(`/admin/grupo-comissao/${id}`)
              .then(() => {
                this.loadGrupos();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  text: err.message,
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
    debounceLoadGrupos: _debounce(function () {
      this.loadGrupos();
    }, 300),
    async openEdit(item) {
      try {
        this.currentItem = clone(item);
        this.$modal.show("ModalGrupoComissao");
      } catch (error) {
        console.error("Erro ao carregar dimensões restritas:", error);
      }
    },
  },
  computed: {
    columnsMaped() {
      return this.table.columns.reduce((acc, col) => {
        acc[col.field] = col;
        return acc;
      }, {});
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadGrupos();
  },
};
</script>
